import { initDataRaw, initDataStartParam, restoreInitData } from '@telegram-apps/sdk-react';

/**
 * Восстанавливает initData из launch params. Вызывается один раз при
 * инициализации. Вне Telegram и без мока источника нет — `retrieveLaunchParams`
 * внутри бросает, и это не повод ронять приложение: сигналы просто остаются
 * пустыми, а getInitDataRaw()/getStartParam() ниже это уже учитывают.
 */
export function restoreInitDataSafe(): void {
  try {
    restoreInitData();
  } catch {
    // нет Telegram и нет мока — initDataRaw()/initDataStartParam() дадут пустые значения
  }
}

/**
 * Сырая initData ровно в том виде, в каком её отдал Telegram: подпись
 * считается по исходной строке, разбирать и пересобирать её нельзя
 * (../clown-back/docs/auth-flow.md). Пустая строка вне Telegram — не ошибка,
 * а нормальное состояние: RestClient просто получит отказ от сервера.
 */
export function getInitDataRaw(): string {
  return initDataRaw() ?? '';
}

/**
 * Код комнаты из ссылки (`t.me/<bot>/<app>?startapp=<CODE>`). Значение стабильно
 * с холодного старта: Telegram не обновляет initData, пока Mini App открыто,
 * поэтому читать его повторно посреди партии не нужно и не имеет смысла.
 */
export function getStartParam(): string | undefined {
  return initDataStartParam();
}
